import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid, TextField, Box, Typography } from '@mui/material'
import BrandedPageHeader from 'components/Layout/BrandedPageHeader'
import Loader from 'components/Loader'
import DirectoryTable from './DirectoryTable'
import { fetchAllEmployerDirectory } from 'src/redux/employerDirectory'

const Directory = () => {
  const dispatch = useDispatch()
  const { loading, directoryEntries } = useSelector(state => state.employerDirectory)
  const [healthcareSystems, setHealthcareSystems] = useState(directoryEntries)
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' })
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    dispatch(fetchAllEmployerDirectory())
  }, [dispatch])

  useEffect(() => {
    setHealthcareSystems(directoryEntries)
  }, [directoryEntries])

  useEffect(() => {
    if (searchText) {
      const filtered = directoryEntries.filter(system =>
        system.name.toLowerCase().includes(searchText.toLowerCase()),
      )
      setHealthcareSystems(filtered)
    } else {
      setHealthcareSystems(directoryEntries)
    }
  }, [searchText, directoryEntries])

  return (
    <>
      <BrandedPageHeader>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Typography variant='h5' sx={{
              color: 'white',
              fontWeight: 'bold',
              mb: 2
            }}>
              Healthcare Directory
            </Typography>
            <Typography variant='caption' sx={{
              color: 'rgba(255,255,255,0.7)',
              display: 'block',
              mb: 0,
              whiteSpace: 'normal',
              wordBreak: 'normal'
            }}>
              Explore our comprehensive directory of healthcare systems and connect directly with in-house recruiters.
            </Typography>
          </Grid>
        </Grid>
      </BrandedPageHeader>
      <Grid container spacing={0} sx={{ width: '100%', m: 0, p: 0 }}>
      {/* Search Bar */}
      <Grid container item xs={12} justifyContent='center' sx={{ mt: 4, mb: 3 }}>
        <Box sx={{ maxWidth: '91.666667%', width: '100%', px: { xs: 1, md: 2 } }}>
          <TextField
            fullWidth
            variant='outlined'
            placeholder='Search'
            label='Search'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontSize: '0.875rem',
                color: 'rgba(0, 0, 0, 0.6)',
                '&.Mui-focused': {
                  color: 'rgba(0, 0, 0, 0.6)',
                },
              },
            }}
            InputProps={{
              sx: {
                height: '48px',
                backgroundColor: 'white',
                borderRadius: '4px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 0, 0, 0.23)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 0, 0, 0.4)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 0, 0, 0.4)',
                },
              },
            }}
            sx={{
              maxWidth: '400px',
              width: '100%',
              '& .MuiInputBase-input': {
                color: 'black',
              },
            }}
          />
        </Box>
      </Grid>

      <Grid
        container
        item
        direction='row'
        alignItems='center'
        spacing={0}
        sx={{ 
          width: '100%',
          overflow: 'hidden',
          px: { xs: 1, md: 2 },
          maxWidth: '91.666667%',
          margin: '0 auto'
        }}
      >
        {loading ? (
          <Loader />
        ) : (
          <DirectoryTable
            healthcareSystems={healthcareSystems}
            sortConfig={sortConfig}
            sortData={key => {
              const direction =
                sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
              setSortConfig({ key, direction })
              const sorted = [...healthcareSystems].sort((a, b) => {
                const compareA = a[key]?.toLowerCase() || ''
                const compareB = b[key]?.toLowerCase() || ''
                return direction === 'asc'
                  ? compareA.localeCompare(compareB)
                  : compareB.localeCompare(compareA)
              })
              setHealthcareSystems(sorted)
            }}
          />
        )}
      </Grid>
    </Grid>
    </>
  )
}

export default Directory
